<template>
  <VDialog
    ref="dialog"
    :opener="props.opener"
    @dismiss="emit('closeModal', $event)"
    aria-describedby="bankTerms-conditions"
  >
    <gsp-dialog-header close="false">
      <div class="heading-loader">
        <h2
          v-t="'labels.bankTermsAndConditionsHeading'"
          id="bankTerms-conditions"
        />
      </div>
    </gsp-dialog-header>
    <gsp-dialog-body>
      <VDialogCloseButton @click="dialog.emitDismiss" icon-shape="arrow-left" />
      <div v-html-t="'htmlMarkup.bankTermsConditionsDescription'" />
    </gsp-dialog-body>
    <gsp-dialog-footer>
      <gsp-secondary-button
        class="gsp-secondary-button-default vm-w-full"
        @click="dialog.emitDismiss"
        v-t="'labels.cancel'"
      />
    </gsp-dialog-footer>
  </VDialog>
</template>

<script setup>
import initModalFeature, {
  modalProps,
  modalEmits,
} from "~/composables/common-modal";

const props = defineProps(modalProps);

const emit = defineEmits(modalEmits);

const { dialog } = initModalFeature();
</script>
